module.exports = "/_next/static/images/5-2cf4e4569df6c02b82393589e8c171e1.gif";